/* eslint-disable */
import React from 'react';

interface Props {
  width: number;
  height: number;
}

const SvgMixSearch = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M78 18H18C15.24 18 13 20.24 13 23V73C13 75.76 15.24 78 18 78H78C80.76 78 83 75.76 83 73V23C83 20.24 80.76 18 78 18Z"
      fill="#DA9EEF"
    />
    <path
      d="M18 19H78C80.2077 19 82 20.7923 82 23V73C82 75.2077 80.2077 77 78 77H18C15.7923 77 14 75.2077 14 73V23C14 20.7923 15.7923 19 18 19Z"
      stroke="url(#paint0_linear_51736_6351)"
      strokeOpacity="0.1"
      strokeWidth="2"
    />
    <path
      d="M74.97 72.0001H21.03C19.91 72.0001 19 71.2001 19 70.2101V37.6001C19 36.6101 19.91 35.8101 21.03 35.8101H74.97C76.09 35.8101 77 36.6101 77 37.6001V70.2101C77 71.2001 76.09 72.0001 74.97 72.0001Z"
      fill="#E8C1F5"
    />
    <g filter="">
      <path
        d="M38.06 29.8098H21.9C20.3 29.8098 19 28.5098 19 26.9098C19 25.3098 20.3 24.0098 21.9 24.0098H38.06C39.66 24.0098 40.96 25.3098 40.96 26.9098C40.96 28.5098 39.66 29.8098 38.06 29.8098Z"
        fill="url(#paint1_linear_51736_6351)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M38.06 29.3098H21.9C20.5761 29.3098 19.5 28.2336 19.5 26.9098C19.5 25.5859 20.5761 24.5098 21.9 24.5098H38.06C39.3839 24.5098 40.46 25.5859 40.46 26.9098C40.46 28.2336 39.3839 29.3098 38.06 29.3098Z"
        stroke="url(#paint2_linear_51736_6351)"
        strokeOpacity="0.1"
        strokeLinecap="round"
        shapeRendering="geometricPrecision"
      />
    </g>
    <g filter="">
      <path
        d="M48.0001 29.8C49.6017 29.8 50.9001 28.5016 50.9001 26.9C50.9001 25.2984 49.6017 24 48.0001 24C46.3985 24 45.1001 25.2984 45.1001 26.9C45.1001 28.5016 46.3985 29.8 48.0001 29.8Z"
        fill="url(#paint3_linear_51736_6351)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M50.4001 26.9C50.4001 28.2255 49.3256 29.3 48.0001 29.3C46.6746 29.3 45.6001 28.2255 45.6001 26.9C45.6001 25.5745 46.6746 24.5 48.0001 24.5C49.3256 24.5 50.4001 25.5745 50.4001 26.9Z"
        stroke="url(#paint4_linear_51736_6351)"
        strokeOpacity="0.1"
        strokeLinecap="round"
        shapeRendering="geometricPrecision"
      />
    </g>
    <g filter="">
      <mask id="path-8-inside-1_51736_6351" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.5039 60.0159C62.3109 60.0159 63.9687 59.3768 65.2639 58.3123L69.719 62.7801C70.012 63.0733 70.4872 63.0733 70.7802 62.7801C71.0732 62.4869 71.0732 62.0115 70.7802 61.7183L66.3231 57.2485C67.3762 55.9558 68.0077 54.3057 68.0077 52.5079C68.0077 48.3614 64.6481 45 60.5039 45C56.3596 45 53 48.3614 53 52.5079C53 56.6545 56.3596 60.0159 60.5039 60.0159ZM62.676 51.2723C63.0587 51.0383 63.5477 51.1447 63.7816 51.517C64.0155 51.8893 63.9092 52.3786 63.5477 52.602L60.9112 54.2613C60.7836 54.3464 60.6347 54.389 60.4859 54.389C60.3583 54.389 60.2201 54.3571 60.1032 54.2933C59.848 54.1443 59.6885 53.8784 59.6885 53.5912V52.7721L58.2427 53.7295C57.8706 53.9741 57.3815 53.8784 57.137 53.5061C56.8925 53.1338 56.9882 52.6445 57.3603 52.3998L60.0394 50.6341C60.2839 50.4745 60.6028 50.4639 60.858 50.6022C61.1132 50.7404 61.2726 51.0064 61.2726 51.3042V52.1552L62.676 51.2723Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.5039 60.0159C62.3109 60.0159 63.9687 59.3768 65.2639 58.3123L69.719 62.7801C70.012 63.0733 70.4872 63.0733 70.7802 62.7801C71.0732 62.4869 71.0732 62.0115 70.7802 61.7183L66.3231 57.2485C67.3762 55.9558 68.0077 54.3057 68.0077 52.5079C68.0077 48.3614 64.6481 45 60.5039 45C56.3596 45 53 48.3614 53 52.5079C53 56.6545 56.3596 60.0159 60.5039 60.0159ZM62.676 51.2723C63.0587 51.0383 63.5477 51.1447 63.7816 51.517C64.0155 51.8893 63.9092 52.3786 63.5477 52.602L60.9112 54.2613C60.7836 54.3464 60.6347 54.389 60.4859 54.389C60.3583 54.389 60.2201 54.3571 60.1032 54.2933C59.848 54.1443 59.6885 53.8784 59.6885 53.5912V52.7721L58.2427 53.7295C57.8706 53.9741 57.3815 53.8784 57.137 53.5061C56.8925 53.1338 56.9882 52.6445 57.3603 52.3998L60.0394 50.6341C60.2839 50.4745 60.6028 50.4639 60.858 50.6022C61.1132 50.7404 61.2726 51.0064 61.2726 51.3042V52.1552L62.676 51.2723Z"
        fill="url(#paint5_linear_51736_6351)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M65.2639 58.3123L65.972 57.6062L65.3306 56.963L64.6289 57.5397L65.2639 58.3123ZM69.719 62.7801L69.0109 63.4862L69.0117 63.487L69.719 62.7801ZM70.7802 62.7801L70.0729 62.0732L70.0729 62.0732L70.7802 62.7801ZM70.7802 61.7183L70.0721 62.4244L70.0729 62.4252L70.7802 61.7183ZM66.3231 57.2485L65.5478 56.6168L64.9782 57.316L65.615 57.9546L66.3231 57.2485ZM63.7816 51.517L64.6284 50.985V50.985L63.7816 51.517ZM62.676 51.2723L62.1543 50.4191L62.1435 50.4259L62.676 51.2723ZM63.5477 52.602L63.022 51.7513L63.0151 51.7556L63.5477 52.602ZM60.9112 54.2613L60.3785 53.415L60.3673 53.4221L60.3562 53.4294L60.9112 54.2613ZM60.1032 54.2933L59.5991 55.1569L59.6115 55.1642L59.6241 55.171L60.1032 54.2933ZM59.6885 52.7721H60.6885V50.9107L59.1365 51.9383L59.6885 52.7721ZM58.2427 53.7295L58.7921 54.5651L58.7948 54.5633L58.2427 53.7295ZM57.137 53.5061L57.9729 52.9571L57.9729 52.9571L57.137 53.5061ZM57.3603 52.3998L57.9097 53.2354L57.9106 53.2348L57.3603 52.3998ZM60.0394 50.6341L59.4929 49.7966L59.4891 49.7991L60.0394 50.6341ZM61.2726 52.1552H60.2726V53.9658L61.8051 53.0016L61.2726 52.1552ZM64.6289 57.5397C63.506 58.4627 62.0708 59.0159 60.5039 59.0159V61.0159C62.5509 61.0159 64.4314 60.291 65.8988 59.0848L64.6289 57.5397ZM70.4271 62.074L65.972 57.6062L64.5558 59.0184L69.0109 63.4862L70.4271 62.074ZM70.0729 62.0732C70.1704 61.9756 70.3288 61.9756 70.4263 62.0732L69.0117 63.487C69.6953 64.171 70.8039 64.171 71.4875 63.487L70.0729 62.0732ZM70.0729 62.4252C69.9757 62.328 69.9757 62.1705 70.0729 62.0732L71.4875 63.487C72.1708 62.8033 72.1708 61.6951 71.4875 61.0114L70.0729 62.4252ZM65.615 57.9546L70.0721 62.4244L71.4883 61.0122L67.0312 56.5424L65.615 57.9546ZM67.0077 52.5079C67.0077 54.0673 66.4609 55.4961 65.5478 56.6168L67.0983 57.8801C68.2916 56.4155 69.0077 54.544 69.0077 52.5079H67.0077ZM60.5039 46C64.0953 46 67.0077 48.9132 67.0077 52.5079H69.0077C69.0077 47.8096 65.2009 44 60.5039 44V46ZM54 52.5079C54 48.9132 56.9124 46 60.5039 46V44C55.8068 44 52 47.8096 52 52.5079H54ZM60.5039 59.0159C56.9124 59.0159 54 56.1027 54 52.5079H52C52 57.2062 55.8068 61.0159 60.5039 61.0159V59.0159ZM64.6284 50.985C64.0895 50.1272 62.9819 49.9132 62.1543 50.4191L63.1976 52.1255C63.1355 52.1634 63.006 52.1621 62.9349 52.0489L64.6284 50.985ZM64.0734 53.4526C64.9317 52.9222 65.1421 51.8026 64.6284 50.985L62.9349 52.0489C62.889 51.9759 62.8867 51.8349 63.022 51.7513L64.0734 53.4526ZM61.4438 55.1077L64.0804 53.4483L63.0151 51.7556L60.3785 53.415L61.4438 55.1077ZM60.4859 55.389C60.8239 55.389 61.1674 55.2925 61.4661 55.0933L60.3562 53.4294C60.3998 53.4004 60.4455 53.389 60.4859 53.389V55.389ZM59.6241 55.171C59.8992 55.3212 60.2042 55.389 60.4859 55.389V53.389C60.5039 53.389 60.5173 53.391 60.5286 53.3938C60.5398 53.3966 60.5581 53.4023 60.5822 53.4155L59.6241 55.171ZM58.6885 53.5912C58.6885 54.2554 59.0558 54.8398 59.5991 55.1569L60.6072 53.4296C60.6403 53.4489 60.6885 53.5014 60.6885 53.5912H58.6885ZM58.6885 52.7721V53.5912H60.6885V52.7721H58.6885ZM58.7948 54.5633L60.2406 53.6059L59.1365 51.9383L57.6906 52.8957L58.7948 54.5633ZM56.3012 54.0551C56.8557 54.8994 57.9686 55.1065 58.7921 54.5651L57.6933 52.8939C57.7295 52.8701 57.7826 52.8575 57.8382 52.8686C57.8949 52.8799 57.9447 52.9143 57.9729 52.9571L56.3012 54.0551ZM56.8109 51.5643C55.9669 52.1192 55.7605 53.232 56.3012 54.0551L57.9729 52.9571C57.9966 52.9932 58.009 53.0459 57.998 53.1011C57.9868 53.1574 57.9526 53.2072 57.9097 53.2354L56.8109 51.5643ZM59.4891 49.7991L56.81 51.5649L57.9106 53.2348L60.5897 51.469L59.4891 49.7991ZM61.3345 49.723C60.7611 49.4123 60.0493 49.4336 59.4929 49.7966L60.5859 51.4715C60.5497 51.4951 60.5132 51.5046 60.4821 51.5057C60.4513 51.5069 60.4165 51.5003 60.3815 51.4813L61.3345 49.723ZM62.2726 51.3042C62.2726 50.6422 61.9146 50.0374 61.3345 49.723L60.3815 51.4813C60.3117 51.4435 60.2726 51.3706 60.2726 51.3042H62.2726ZM62.2726 52.1552V51.3042H60.2726V52.1552H62.2726ZM62.1435 50.4259L60.7401 51.3088L61.8051 53.0016L63.2085 52.1187L62.1435 50.4259Z"
        fill="url(#paint6_linear_51736_6351)"
        fillOpacity="0.1"
        mask="url(#path-8-inside-1_51736_6351)"
      />
    </g>
    <g filter="">
      <mask id="path-10-inside-2_51736_6351" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.9024 58.1951C31.8683 58.1951 32.7268 57.8732 33.478 57.3366C33.6927 57.122 34.2293 57.2293 34.4439 57.5512C34.7659 57.8732 34.7659 58.4098 34.3366 58.7317C33.3707 59.3756 32.1902 59.8049 30.9024 59.8049C29.2927 59.8049 27.7902 59.161 26.7171 58.0878C25.6439 57.0146 25 55.5122 25 53.9024C25 52.2927 25.6439 50.7902 26.7171 49.7171C27.7902 48.6439 29.2927 48 30.9024 48C32.5122 48 34.0146 48.6439 34.9805 49.7171L38.7366 53.4732C39.0585 53.7951 39.0585 54.3317 38.7366 54.6537C38.6293 54.761 38.4146 54.8683 38.2 54.8683C37.9854 54.8683 37.7707 54.761 37.6634 54.6537L33.9073 50.8976C33.1561 50.039 32.0829 49.6098 30.9024 49.6098C29.8293 49.6098 28.7561 50.1463 27.8976 50.8976C27.039 51.6488 26.6098 52.722 26.6098 53.9024C26.6098 55.0829 27.1463 56.0488 27.8976 56.9073C28.6488 57.7659 29.722 58.1951 30.9024 58.1951ZM41.0976 48C42.7073 48 44.2098 48.6439 45.2829 49.7171C46.3561 50.7902 47 52.2927 47 53.9024C47 55.5122 46.3561 57.0146 45.2829 58.0878C44.2098 59.161 42.7073 59.8049 41.0976 59.8049C39.4878 59.8049 37.9854 59.161 36.9122 58.0878L33.1561 54.3317C32.8341 54.0098 32.8341 53.4732 33.1561 53.1512C33.478 52.8293 34.0146 52.8293 34.3366 53.1512L38.0927 56.9073C38.8439 57.7659 39.9171 58.1951 41.0976 58.1951C42.278 58.1951 43.2439 57.6585 44.1024 56.9073C44.961 56.1561 45.3902 55.0829 45.3902 53.9024C45.3902 52.722 44.961 51.6488 44.2098 50.7902C43.4585 49.9317 42.3854 49.5024 41.2049 49.5024C40.239 49.5024 39.3805 49.8244 38.6293 50.361C38.3073 50.5756 37.878 50.5756 37.5561 50.2537C37.2341 49.9317 37.2341 49.3951 37.6634 49.0732C38.6293 48.4293 39.8098 48 41.0976 48Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.9024 58.1951C31.8683 58.1951 32.7268 57.8732 33.478 57.3366C33.6927 57.122 34.2293 57.2293 34.4439 57.5512C34.7659 57.8732 34.7659 58.4098 34.3366 58.7317C33.3707 59.3756 32.1902 59.8049 30.9024 59.8049C29.2927 59.8049 27.7902 59.161 26.7171 58.0878C25.6439 57.0146 25 55.5122 25 53.9024C25 52.2927 25.6439 50.7902 26.7171 49.7171C27.7902 48.6439 29.2927 48 30.9024 48C32.5122 48 34.0146 48.6439 34.9805 49.7171L38.7366 53.4732C39.0585 53.7951 39.0585 54.3317 38.7366 54.6537C38.6293 54.761 38.4146 54.8683 38.2 54.8683C37.9854 54.8683 37.7707 54.761 37.6634 54.6537L33.9073 50.8976C33.1561 50.039 32.0829 49.6098 30.9024 49.6098C29.8293 49.6098 28.7561 50.1463 27.8976 50.8976C27.039 51.6488 26.6098 52.722 26.6098 53.9024C26.6098 55.0829 27.1463 56.0488 27.8976 56.9073C28.6488 57.7659 29.722 58.1951 30.9024 58.1951ZM41.0976 48C42.7073 48 44.2098 48.6439 45.2829 49.7171C46.3561 50.7902 47 52.2927 47 53.9024C47 55.5122 46.3561 57.0146 45.2829 58.0878C44.2098 59.161 42.7073 59.8049 41.0976 59.8049C39.4878 59.8049 37.9854 59.161 36.9122 58.0878L33.1561 54.3317C32.8341 54.0098 32.8341 53.4732 33.1561 53.1512C33.478 52.8293 34.0146 52.8293 34.3366 53.1512L38.0927 56.9073C38.8439 57.7659 39.9171 58.1951 41.0976 58.1951C42.278 58.1951 43.2439 57.6585 44.1024 56.9073C44.961 56.1561 45.3902 55.0829 45.3902 53.9024C45.3902 52.722 44.961 51.6488 44.2098 50.7902C43.4585 49.9317 42.3854 49.5024 41.2049 49.5024C40.239 49.5024 39.3805 49.8244 38.6293 50.361C38.3073 50.5756 37.878 50.5756 37.5561 50.2537C37.2341 49.9317 37.2341 49.3951 37.6634 49.0732C38.6293 48.4293 39.8098 48 41.0976 48Z"
        fill="url(#paint7_linear_51736_6351)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M33.478 57.3366L34.0593 58.1503L34.1266 58.1022L34.1852 58.0437L33.478 57.3366ZM34.4439 57.5512L33.6119 58.1059L33.6668 58.1883L33.7368 58.2583L34.4439 57.5512ZM34.3366 58.7317L34.8913 59.5638L34.9144 59.5484L34.9366 59.5317L34.3366 58.7317ZM26.7171 58.0878L27.4242 57.3807L26.7171 58.0878ZM26.7171 49.7171L27.4242 50.4242L26.7171 49.7171ZM34.9805 49.7171L34.2372 50.386L34.2548 50.4056L34.2734 50.4242L34.9805 49.7171ZM38.7366 53.4732L39.4437 52.7661L39.4437 52.7661L38.7366 53.4732ZM38.7366 54.6537L39.4437 55.3608L39.4437 55.3608L38.7366 54.6537ZM37.6634 54.6537L36.9563 55.3608L36.9563 55.3608L37.6634 54.6537ZM33.9073 50.8976L33.1547 51.5561L33.1767 51.5811L33.2002 51.6047L33.9073 50.8976ZM27.8976 50.8976L27.2391 50.145L27.2391 50.145L27.8976 50.8976ZM27.8976 56.9073L27.145 57.5658L27.145 57.5658L27.8976 56.9073ZM45.2829 49.7171L44.5758 50.4242L44.5758 50.4242L45.2829 49.7171ZM45.2829 58.0878L44.5758 57.3807L44.5758 57.3807L45.2829 58.0878ZM36.9122 58.0878L37.6193 57.3807L36.9122 58.0878ZM33.1561 54.3317L32.449 55.0388V55.0388L33.1561 54.3317ZM33.1561 53.1512L32.449 52.4441L32.449 52.4441L33.1561 53.1512ZM34.3366 53.1512L35.0437 52.4441L34.3366 53.1512ZM38.0927 56.9073L38.8453 56.2488L38.8233 56.2238L38.7998 56.2002L38.0927 56.9073ZM44.1024 56.9073L43.4439 56.1547L44.1024 56.9073ZM44.2098 50.7902L44.9623 50.1317V50.1317L44.2098 50.7902ZM38.6293 50.361L39.184 51.193L39.1974 51.1841L39.2105 51.1747L38.6293 50.361ZM37.5561 50.2537L38.2632 49.5466V49.5466L37.5561 50.2537ZM37.6634 49.0732L37.1087 48.2411L37.0856 48.2565L37.0634 48.2732L37.6634 49.0732ZM32.8968 56.5229C32.2905 56.9559 31.6315 57.1951 30.9024 57.1951V59.1951C32.1051 59.1951 33.1631 58.7904 34.0593 58.1503L32.8968 56.5229ZM35.276 56.9965C34.9924 56.5712 34.5509 56.3464 34.1705 56.2649C33.8288 56.1917 33.2232 56.1772 32.7709 56.6295L34.1852 58.0437C34.0601 58.1688 33.9294 58.2072 33.8665 58.2185C33.8022 58.2301 33.7632 58.223 33.7514 58.2205C33.7374 58.2175 33.7233 58.2125 33.7057 58.2016C33.6882 58.1908 33.6499 58.163 33.6119 58.1059L35.276 56.9965ZM34.9366 59.5317C35.8665 58.8343 35.891 57.5841 35.151 56.8441L33.7368 58.2583C33.6996 58.2212 33.669 58.1574 33.6739 58.0791C33.6763 58.0402 33.6874 58.0041 33.7035 57.9748C33.7113 57.9606 33.7193 57.9498 33.7259 57.9423C33.7325 57.9348 33.7368 57.9316 33.7366 57.9317L34.9366 59.5317ZM30.9024 60.8049C32.4156 60.8049 33.786 60.3006 34.8913 59.5638L33.7819 57.8997C32.9554 58.4506 31.9649 58.8049 30.9024 58.8049V60.8049ZM26.01 58.7949C27.2699 60.0549 29.0264 60.8049 30.9024 60.8049V58.8049C29.559 58.8049 28.3106 58.2671 27.4242 57.3807L26.01 58.7949ZM24 53.9024C24 55.7785 24.75 57.535 26.01 58.7949L27.4242 57.3807C26.5378 56.4943 26 55.2459 26 53.9024H24ZM26.01 49.01C24.75 50.2699 24 52.0264 24 53.9024H26C26 52.559 26.5378 51.3106 27.4242 50.4242L26.01 49.01ZM30.9024 47C29.0264 47 27.2699 47.75 26.01 49.01L27.4242 50.4242C28.3106 49.5378 29.559 49 30.9024 49V47ZM35.7238 49.0481C34.5504 47.7443 32.7677 47 30.9024 47V49C32.2567 49 33.4789 49.5435 34.2372 50.386L35.7238 49.0481ZM39.4437 52.7661L35.6876 49.01L34.2734 50.4242L38.0295 54.1803L39.4437 52.7661ZM39.4437 55.3608C40.1562 54.6483 40.1562 53.4785 39.4437 52.7661L38.0295 54.1803C37.9907 54.1415 37.9781 54.0961 37.9781 54.0634C37.9781 54.0307 37.9907 53.9854 38.0295 53.9466L39.4437 55.3608ZM38.2 55.8683C38.6972 55.8683 39.1615 55.643 39.4437 55.3608L38.0295 53.9466C38.0593 53.9167 38.0818 53.9011 38.0914 53.8949C38.1022 53.8878 38.1097 53.8842 38.1146 53.8821C38.1195 53.88 38.1464 53.8683 38.2 53.8683V55.8683ZM36.9563 55.3608C37.2385 55.643 37.7028 55.8683 38.2 55.8683V53.8683C38.2536 53.8683 38.2806 53.88 38.2854 53.8821C38.2903 53.8842 38.2978 53.8878 38.3086 53.8949C38.3182 53.9011 38.3407 53.9167 38.3705 53.9465L36.9563 55.3608ZM33.2002 51.6047L36.9563 55.3608L38.3705 53.9466L34.6144 50.1905L33.2002 51.6047ZM30.9024 50.6098C31.836 50.6098 32.6191 50.9439 33.1547 51.5561L34.6599 50.2391C33.6931 49.1342 32.3299 48.6098 30.9024 48.6098V50.6098ZM28.5561 51.6501C29.3033 50.9963 30.1516 50.6098 30.9024 50.6098V48.6098C29.507 48.6098 28.2089 49.2964 27.2391 50.145L28.5561 51.6501ZM27.6098 53.9024C27.6098 52.9689 27.9439 52.1858 28.5561 51.6501L27.2391 50.145C26.1342 51.1118 25.6098 52.475 25.6098 53.9024H27.6098ZM28.6501 56.2488C27.9853 55.489 27.6098 54.7489 27.6098 53.9024H25.6098C25.6098 55.417 26.3074 56.6086 27.145 57.5658L28.6501 56.2488ZM30.9024 57.1951C29.9689 57.1951 29.1858 56.861 28.6501 56.2488L27.145 57.5658C28.1118 58.6707 29.475 59.1951 30.9024 59.1951V57.1951ZM45.99 49.01C44.7301 47.75 42.9736 47 41.0976 47V49C42.441 49 43.6894 49.5378 44.5758 50.4242L45.99 49.01ZM48 53.9024C48 52.0264 47.25 50.2699 45.99 49.01L44.5758 50.4242C45.4622 51.3106 46 52.559 46 53.9024H48ZM45.99 58.7949C47.25 57.535 48 55.7785 48 53.9024H46C46 55.2459 45.4622 56.4943 44.5758 57.3807L45.99 58.7949ZM41.0976 60.8049C42.9736 60.8049 44.7301 60.0549 45.99 58.7949L44.5758 57.3807C43.6894 58.2671 42.441 58.8049 41.0976 58.8049V60.8049ZM36.2051 58.7949C37.465 60.0549 39.2215 60.8049 41.0976 60.8049V58.8049C39.7541 58.8049 38.5057 58.2671 37.6193 57.3807L36.2051 58.7949ZM32.449 55.0388L36.2051 58.7949L37.6193 57.3807L33.8632 53.6246L32.449 55.0388ZM32.449 52.4441C31.7365 53.1566 31.7365 54.3263 32.449 55.0388L33.8632 53.6246C33.902 53.6634 33.9146 53.7087 33.9146 53.7415C33.9146 53.7742 33.902 53.8195 33.8632 53.8583L32.449 52.4441ZM35.0437 52.4441C34.3312 51.7316 33.1615 51.7316 32.449 52.4441L33.8632 53.8583C33.8244 53.8971 33.7791 53.9098 33.7463 53.9098C33.7136 53.9098 33.6683 53.8971 33.6295 53.8583L35.0437 52.4441ZM38.7998 56.2002L35.0437 52.4441L33.6295 53.8583L37.3856 57.6144L38.7998 56.2002ZM41.0976 57.1951C40.164 57.1951 39.3809 56.861 38.8453 56.2488L37.3401 57.5658C38.3069 58.6707 39.6701 59.1951 41.0976 59.1951V57.1951ZM43.4439 56.1547C42.6841 56.8196 41.944 57.1951 41.0976 57.1951V59.1951C42.6121 59.1951 43.8037 58.4975 44.7609 57.6599L43.4439 56.1547ZM44.3902 53.9024C44.3902 54.836 44.0561 55.6191 43.4439 56.1547L44.7609 57.6599C45.8658 56.6931 46.3902 55.3299 46.3902 53.9024H44.3902ZM43.4572 51.4487C44.0562 52.1334 44.3902 52.9751 44.3902 53.9024H46.3902C46.3902 52.4688 45.8657 51.1642 44.9623 50.1317L43.4572 51.4487ZM41.2049 50.5024C42.1384 50.5024 42.9215 50.8366 43.4572 51.4487L44.9623 50.1317C43.9956 49.0268 42.6323 48.5024 41.2049 48.5024V50.5024ZM39.2105 51.1747C39.8168 50.7416 40.4758 50.5024 41.2049 50.5024V48.5024C40.0022 48.5024 38.9442 48.9071 38.048 49.5472L39.2105 51.1747ZM36.849 50.9608C37.5408 51.6526 38.5053 51.6454 39.184 51.193L38.0746 49.5289C38.0831 49.5232 38.1131 49.5074 38.1639 49.5111C38.1893 49.5129 38.2137 49.5194 38.2345 49.529C38.2553 49.5386 38.2643 49.5476 38.2632 49.5466L36.849 50.9608ZM37.0634 48.2732C36.1335 48.9706 36.109 50.2208 36.849 50.9608L38.2632 49.5466C38.3004 49.5837 38.331 49.6474 38.3261 49.7258C38.3237 49.7647 38.3126 49.8007 38.2965 49.8301C38.2887 49.8443 38.2807 49.8551 38.2741 49.8626C38.2675 49.8701 38.2632 49.8733 38.2634 49.8732L37.0634 48.2732ZM41.0976 47C39.5844 47 38.214 47.5043 37.1087 48.2411L38.2181 49.9052C39.0446 49.3542 40.0351 49 41.0976 49V47Z"
        fill="url(#paint8_linear_51736_6351)"
        fillOpacity="0.1"
        mask="url(#path-10-inside-2_51736_6351)"
      />
    </g>
    <defs>
      <filter
        id="filter0_di_51736_6351"
        x="19"
        y="24.0098"
        width="21.96"
        height="6.7998"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_6351"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_6351"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_6351"
        />
      </filter>
      <filter
        id="filter1_di_51736_6351"
        x="45.1001"
        y="24"
        width="5.7998"
        height="6.7998"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_6351"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_6351"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_6351"
        />
      </filter>
      <filter
        id="filter2_di_51736_6351"
        x="53"
        y="45"
        width="18"
        height="19"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_6351"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_6351"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_6351"
        />
      </filter>
      <filter
        id="filter3_di_51736_6351"
        x="25"
        y="48"
        width="22"
        height="12.8047"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_6351"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_6351"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_6351"
        />
      </filter>
      <linearGradient
        id="paint0_linear_51736_6351"
        x1="48"
        y1="18"
        x2="48"
        y2="78"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_51736_6351"
        x1="29.98"
        y1="24.0098"
        x2="29.98"
        y2="29.8098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_51736_6351"
        x1="29.98"
        y1="24.0098"
        x2="29.98"
        y2="29.8098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_51736_6351"
        x1="48.0001"
        y1="24"
        x2="48.0001"
        y2="29.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_51736_6351"
        x1="48.0001"
        y1="24"
        x2="48.0001"
        y2="29.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_51736_6351"
        x1="62"
        y1="45"
        x2="62"
        y2="63"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_51736_6351"
        x1="62"
        y1="45"
        x2="62"
        y2="63"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_51736_6351"
        x1="36"
        y1="48"
        x2="36"
        y2="59.8049"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_51736_6351"
        x1="36"
        y1="48"
        x2="36"
        y2="59.8049"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgMixSearch;
